<tcc-mono-dialog-layout [title]="'Stal naar stal'" (onSave)="save()">
  <form [formGroup]="form" (ngSubmit)="save()">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-input
            mode="md"
            formControlName="date"
            labelPlacement="stacked"
            fill="solid"
            errorText="Datum is verplicht"
            type="date"
          >
            <ion-text slot="label" class="form-label required">
              Datum
            </ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="12">
          <ion-item lines="none" [detail]="false">
            <ion-segment mode="ios" formControlName="transportType">
              <ion-segment-button [value]="'stable'">
                <ion-label>Naar stal</ion-label>
              </ion-segment-button>
              <ion-segment-button [value]="'hub'">
                <ion-label>Naar VC</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-item>
        </ion-col>
        <ion-col size="12" *ngIf="form.get('transportType').value === 'stable'">
          <ion-item
            lines="none"
            [detail]="false"
            button
            (click)="editStable()"
            class="picker-layout"
          >
            <ion-label position="stacked" class="form-label required">
              Selecteer een stal
            </ion-label>
            <ion-text color="primary" class="ion-margin-horizontal">
              <p>
                {{ stableName }}
              </p>
            </ion-text>
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <ion-item
            lines="none"
            [detail]="false"
            *ngIf="form.get('transportType').value === 'hub'"
          >
            <ion-segment mode="ios" formControlName="hub_id">
              <ion-segment-button
                *ngFor="let hub of hubs$ | async"
                [value]="hub.id"
              >
                <ion-label>{{ hub.name }}</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</tcc-mono-dialog-layout>
